import { Link } from "react-router-dom";
import classNames from "classnames";
import { Wrap } from "components";
import styles from "./Avatar.module.css";

interface AvatarProps {
  alt: string;
  src?: string;
  badge?: JSX.Element;
  size?: "32px" | "64px";
  link?: string;
}

const Avatar: React.FC<AvatarProps> = ({
  src,
  alt,
  badge,
  size = "64px",
  link,
}) => {
  const props = {
    className: classNames(styles.container, link && styles.link),
    style: { "--size": size } as React.CSSProperties,
  };

  return (
    <Wrap
      if={Boolean(link)}
      with={(children) => (
        <Link to={link!} {...props}>
          {children}
        </Link>
      )}
      else={(children) => <div {...props}>{children}</div>}
    >
      {src ? (
        <img className={styles.image} alt={alt} src={src} />
      ) : (
        <span className={styles.default}>{alt}</span>
      )}
      {badge && badge}
    </Wrap>
  );
};

export { Avatar };
